import { Component, inject } from '@angular/core';

import { LayoutService } from '../../services/layout.service';
import { PRODUCT_NAME } from '../../../core/constant/product.constant';

@Component({
    standalone: false,
    selector: 'app-admin-header',
    templateUrl: './admin-header.component.html',
})
export class AdminHeaderComponent {
    protected readonly layoutService = inject(LayoutService);
    protected readonly productName = PRODUCT_NAME;
}
